// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1HourSchema } from './v1/hourSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';

export const listTimeEntriesPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID for the time entries you want to retrieve"),
});

export const listTimeEntriesQueryParamsSchema = z.object({
  since: z.optional(z.string().date().describe("Filter time entries from this date (inclusive). Both since and upto needs to be present")),
  upto: z.optional(z.string().date().describe("Filter time entries up to this date (inclusive). Both since and upto needs to be present")),
  day: z.optional(z.string().date().describe("Filter time entries for a specific date. Defaults to current date if omitted. Disregarded if since and upto is present")),
  hour_ids: z.optional(z.coerce.string().describe("Comma-separated list of time entry IDs to filter by")),
  sort: z.optional(z.enum(["day", "created_at", "updated_at"]).describe("Field to sort by")),
  order: z.optional(z.enum(["asc", "desc"]).describe("Sort order")),
  per_page: z.optional(z.number().int().min(1).max(5000).describe("Number of results per page (max 5000)")),
  page: z.optional(z.number().int().min(1).describe("Page number for pagination")),
  project_id: z.optional(z.number().int().describe("Filter by project ID")),
  user_id: z.optional(z.number().int().describe("Filter by user ID")),
  autosheet_proposal_id: z.optional(z.coerce.string().describe("Filter to hours linked to a specific AutoSheet proposal UUID")),
  include_linked_metadata: z.optional(z.boolean().describe("When true, response includes a linked_work_items array with id, title, and sync_status for each linked work item. Requires the integrations feature to be enabled on the account.")),
}).optional();

export const listTimeEntriesHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Time entries with linked work items
 */
export const listTimeEntries200Schema = z.array(z.lazy(() => v1HourSchema));

/**
 * @description Unauthorized
 */
export const listTimeEntries401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

export const listTimeEntriesQueryResponseSchema = z.lazy(() => listTimeEntries200Schema);
